import React, { useState } from "react";
import { IPermissionProps } from "../../../../models/Login";
import { IModel } from "./DiceSetting";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { Accordion, AccordionTab } from "primereact/accordion";
import DiceCompanySettingTable from "./diceCompanySetting/DiceCompanySettingTable";
import DiceBranchSettingTable from "./diceBranchSetting/DiceBranchSettingTable";
import DiceTeamSettingTable from "./diceTeamSetting/DiceTeamSettingTable";
import DiceUserSettingTable from "./diceUserSetting/DiceUserSettingTable";

interface IProps {
  setModal: (modal: IModel) => void;
  toast: any;
  permissions: IPermissionProps;
  reload: boolean;
}

const Table = (props: IProps) => {
  const [activeIndex, setActiveIndex] = useState<number | number[]>();
  const openEdit = () => {
    props.setModal({ open: true });
  };
  const handleCollapseAll = () => {
    setActiveIndex([]);
  };

  const handleExpandAll = () => {
    setActiveIndex([0, 1, 2, 3]);
  };

  const leftToolbarTemplate = () => {
    return (
      <>
        <Button label="Expand All" className="p-button-success mr-2 bg-primary" onClick={handleExpandAll} />
        <Button label="Collapse All" className="p-button-success mr-2 bg-primary" onClick={handleCollapseAll} />
      </>
    );
  };

  const rightToolbarTemplate = () => {
    return <Button label="Update" icon="pi pi-pencil" className="p-button-success mr-2 bg-primary" onClick={openEdit} />;
  };

  return (
    <>
      <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
      <Accordion multiple activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
        <AccordionTab header="Dice Company Wise Setting">
          <DiceCompanySettingTable />
        </AccordionTab>
        <AccordionTab header="Dice Branch Wise Setting">
          <DiceBranchSettingTable />
        </AccordionTab>
        <AccordionTab header="Dice Team Wise Setting">
          <DiceTeamSettingTable />
        </AccordionTab>
        <AccordionTab header="Dice User Wise Setting">
          <DiceUserSettingTable />
        </AccordionTab>
      </Accordion>
    </>
  );
};

export default Table;
